<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage['PTSET']['PTSET']}}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <label class="col-form-label-sm inline inline50">
                                    <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}} :</span>
                                </label>
                                <customtreeselect :multiple="false"
                                                  :load-options="loadAgentOptions"
                                                  :options="ddAgentList"
                                                  :auto-load-root-options="convertToBool(searchAgent)"
                                                  :disable-branch-nodes="false"
                                                  @input="selectAgentOptions"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  v-model="searchAgent" />
                            </div>
                            <div class='searchCol'>
                                <label class="col-form-label-sm inline inline50">
                                    <span class='searchLabel'>{{this.getLanguage["MTA"]["C"]}} :</span>
                                    <div class="custom-tooltip">
                                        <i class="fa fa-question-circle"></i>
                                        <span class="custom-tooltiptext2">{{getLanguage["PTT"]["NOCURRSEL"]}}</span>
                                    </div>
                                </label>
                                <treeselect :options="ddCurrency"
                                            :placeholder="this.utilGetDDLanguage('MTA.C')"
                                            v-model="searchCurrency" />
                            </div>
                            <div class='searchCol'>
                                <label class="col-form-label-sm inline inline50">
                                    <span class='searchLabel'>{{this.getLanguage["BETRPT"]["GP"]}} :</span>
                                </label>
                                <treeselect :multiple="true"
                                            :load-options="loadGameProviderOptions"
                                            :defaultExpandLevel="1"
                                            valueConsistsOf="LEAF_PRIORITY"
                                            :options="ddGameProviderList"
                                            :auto-load-root-options="true"
                                            @input="selectGameProvider"
                                            :placeholder="this.utilGetDDLanguage('BETRPT.GP')"
                                            v-model="searchGameProviderId"
                                            :limit="1"
                                            :limitText="count => `+${count}`"
                                            class="gp-dropdown" />
                            </div>

                        </div>
                        <div class='searchBtnCol'>
                            <CButton class='searchBtn' size="sm" block color="success" @click=" getReportList()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
            <template v-if="this.bool_showPasteForm && getUserInfo.AT == 0">
                <div class='table-wrapper'>
                    <div class="custom-table-wrapper">
                        <table class='custom-table custom-tableMP afb-blue'>
                            <thead>
                                <tr>
                                    <th>{{this.getLanguage['BETRPT']['GP']}}</th>
                                    <th v-if="str_searchCurrency !=2">
                                        {{this.getLanguage['GL']['CURR']}}
                                    </th>
                                    <th>
                                        {{this.getLanguage['PTRPT']['PPT']}}
                                    </th>
                                    <th v-if="getUserInfo.AT == 0">
                                        {{this.getLanguage['PTRPT']['SPT']}}
                                    </th>
                                    <th v-if="getUserInfo.AT <= 1">
                                        {{ this.getLanguage['PTRPT']['SAPT'] }}
                                    </th>
                                    <th v-if="getUserInfo.AT <= 2">
                                        {{ this.getLanguage['PTRPT']['MAPT'] }}
                                    </th>
                                    <th v-if="getUserInfo.AT <= 3">
                                        {{ this.getLanguage['PTRPT']['APT'] }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody v-if="arr_GPPTList.D && arr_GPPTList.D.Items && arr_GPPTList.D.Items.length > 0">
                                <tr>
                                    <td>{{renderProviderName(var_GP_DefaultName)}}</td>
                                    <td v-if="str_searchCurrency !=2">{{str_searchCurrency}}</td>
                                    <td>{{ formatNumber(var_GP_DefaultPT, 2, '') }}</td>
                                    <td v-if="getUserInfo.AT == 0" :class="arr_COPYLIST.CPT >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">
                                        {{ formatNumber(arr_COPYLIST.CPT, 2, '') }}
                                    </td>
                                    <td v-if="getUserInfo.AT<= 1" :class="generateFieldClassForCopyForm()">
                                        <input class="form-control form-control-sm"
                                               style="width: 60px;
                                        float: right;"
                                               v-model="arr_COPYLIST.SMPT"
                                               type="number"
                                               @change="changeProviderDefaultPT()" />
                                    </td>
                                    <td v-if="getUserInfo.AT<= 2" :class="generateFieldClassForCopyForm()">
                                        <input class="form-control form-control-sm"
                                               style="width: 60px;
                                        float: right;"
                                               v-model="arr_COPYLIST.MAPT"
                                               type="number"
                                               @change="changeProviderDefaultPT()" />
                                    </td>
                                    <td v-if="getUserInfo.AT<= 3" :class="generateFieldClassForCopyForm()">
                                        <input class="form-control form-control-sm"
                                               style="width: 60px;
                                        float: right;"
                                               v-model="arr_COPYLIST.AGPT"
                                               type="number"
                                               @change="changeProviderDefaultPT()" />
                                    </td>
                                </tr>
                            </tbody>
                            <tr v-else>
                                <td colspan="100%">{{this.getLanguage['GL']['NR']}}</td>
                            </tr>
                        </table>
                    </div>
                    <header class="table-header">
                        <strong></strong>
                        <div>
                            <CButton v-if="arr_GPPTList.D && arr_GPPTList.D.Items && arr_GPPTList.D.Items.length > 0" class='searchBtn' size="sm" block color="success" @click="copyPTtoAll()"><span>{{this.getLanguage["BTN"]["C"]}}</span></CButton>
                        </div>
                    </header>
                </div>
            </template>
            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{this.getLanguage['PTSET']['PTSETL']}}</strong>
                    <div v-if="arr_reportList != null && arr_reportList.length > 0">
                        <CButton v-if="getUserInfo.AT < 3 && checkModuleAccess('APTRS', 'AGS', constAccessType.edit)" class='searchBtn' size="sm" block color="success" @click="savePTAll()"><span>{{this.getLanguage["BTN"]["SV"]}}</span></CButton>
                    </div>
                    <div  v-if="getUserInfo.AT ==0 && getUserInfo.DN =='secretagent'">
                        <CButton  class='searchBtn' size="sm" block color="success" @click="outputToConsole()"><span>Export</span></CButton>
                    </div>
                </header>
                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage['BETRPT']['GP']}}</th>
                                <th v-if="str_searchCurrency !=2">
                                    {{this.getLanguage['GL']['CURR']}}
                                </th>
                                <th class="tableCtnRight">
                                    {{this.getLanguage['PTRPT']['PPT']}}
                                </th>
                                <th v-if="getUserInfo.AT == 0" class="tableCtnRight">
                                    {{this.getLanguage['PTRPT']['SPT']}}
                                </th>
                                <th v-if="getUserInfo.AT <= 1" class="tableCtnRight">
                                    {{ this.getLanguage['PTRPT']['SAPT'] }}
                                </th>
                                <th v-if="getUserInfo.AT <= 2" class="tableCtnRight">
                                    {{ this.getLanguage['PTRPT']['MAPT'] }}
                                </th>
                                <th v-if="getUserInfo.AT <= 3" class="tableCtnRight">
                                    {{ this.getLanguage['PTRPT']['APT'] }}
                                </th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage['BETRPT']['GP']}}</th>
                                <th v-if="str_searchCurrency !=2">
                                    {{this.getLanguage['GL']['CURR']}}
                                </th>
                                <th class="tableCtnRight">
                                    {{this.getLanguage['PTRPT']['PPT']}}
                                </th>
                                <th v-if="getUserInfo.AT == 0" class="tableCtnRight">
                                    {{this.getLanguage['PTRPT']['SPT']}}
                                </th>
                                <th v-if="getUserInfo.AT <= 1" class="tableCtnRight">
                                    {{ this.getLanguage['PTRPT']['SAPT'] }}
                                </th>
                                <th v-if="getUserInfo.AT <= 2" class="tableCtnRight">
                                    {{ this.getLanguage['PTRPT']['MAPT'] }}
                                </th>
                                <th v-if="getUserInfo.AT <= 3" class="tableCtnRight">
                                    {{ this.getLanguage['PTRPT']['APT'] }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_reportList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <template v-for="(data,index) in arr_reportList">
                            <tr v-if="data.AGN" class="table-row-subheader">
                                <td colspan="11">
                                    <router-link :to="{ path:'/R/WINLV2', query:{ sagi: '3-'+data.PT.CAGI3, agi: data.PT.CAGI3, as: 't' }}" target="_blank">
                                        <b>{{ data.AGN }} ({{data.PC}})</b>
                                    </router-link>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ renderProviderName(data.PN) }}</td>
                                <td width="100px" v-if="str_searchCurrency != 2">
                                    {{ str_searchCurrency}}
                                </td>
                                <td v-if="bool_showPasteForm && getUserInfo.AT == 0" width="100px" :class="data.PPT && data.PPT.PT >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">
                                    <!--{{ formatNumber(data.PPT? data.PPT.PT: 0, 2, '') }}-->
                                    {{ formatNumber(var_GP_DefaultPT, 2, '') }}
                                </td>
                                <td v-else width="100px" :class="data.PPT && data.PPT.PT >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">
                                    {{ formatNumber(data.PPT? data.PPT.PT: 0, 2, '') }}
                                </td>
                                <td width="100px" v-if="getUserInfo.AT == 0" :class="data.PT && data.PT.PT >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">
                                    <!--
                                    <input class="form-control form-control-sm" style="width: 60px;float: right;"
                                           v-model="data.PT.PT"
                                           type="number"
                                           @change="changePT(data)"
                                           v-if="convertToBool(data.PT.AGI)" />
                                    -->
                                    {{ formatNumber(data.PT.PT? data.PT.PT: 0, 2, '') }}
                                </td>
                                <td width="120px" v-if="getUserInfo.AT <= 1" :class="generateFieldClass(data)" class="tableCtnRight">
                                    <!--{{ formatNumber(data.SAPT.PT,2, '') }}-->
                                    <span :class="data.SAPT && data.SAPT.PT >= 0? 'positive-number': 'negative-number'" v-if="getUserInfo.AT >= 1">{{ formatNumber(data.SAPT? data.SAPT.PT: 0, 2, '') }}</span>
                                    <input class="form-control form-control-sm"
                                           style="width: 70px;
                                        float: right;"
                                           v-model="data.SAPT.PT"
                                           type="number"
                                           @change="changePT(data)"
                                           v-if="convertToBool(data.SAPT.AGI) && getUserInfo.AT < 1" />
                                </td>
                                <td width="120px" v-if="getUserInfo.AT <= 2" :class="generateFieldClass(data)" class="tableCtnRight">
                                    <!--{{ formatNumber(data.MAPT.PT, 2, '') }}-->
                                    <span :class="data.MAPT && data.MAPT.PT >= 0? 'positive-number': 'negative-number'" v-if="getUserInfo.AT >= 2">{{ formatNumber(data.MAPT? data.MAPT.PT: 0, 2, '') }}</span>
                                    <input class="form-control form-control-sm"
                                           style="width: 70px;
                                        float: right;"
                                           v-model="data.MAPT.PT"
                                           type="number"
                                           @change="changePT(data)"
                                           v-if="convertToBool(data.MAPT.AGI) && getUserInfo.AT < 2" />
                                </td>
                                <td width="120px" v-if="getUserInfo.AT <= 3" :class="generateFieldClass(data)" class="tableCtnRight">
                                    <!--{{ formatNumber(data.APT.PT, 2, '') }}-->
                                    <span :class="data.APT && data.APT.PT >= 0? 'positive-number': 'negative-number'" v-if="getUserInfo.AT >= 3">{{ formatNumber(data.APT? data.APT.PT: 0, 2, '') }}</span>
                                    <input class="form-control form-control-sm"
                                           style="width: 70px;
                                        float: right;"
                                           v-model="data.APT.PT"
                                           type="number"
                                           @change="changePT(data)"
                                           v-if="convertToBool(data.APT.AGI)  && getUserInfo.AT < 3" />
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
                <header class="table-header">
                    <strong></strong>
                    <div class="mt-2" v-if="arr_reportList != null && arr_reportList.length > 0">
                        <CButton v-if="getUserInfo.AT < 3 && checkModuleAccess('APTRS', 'AGS', constAccessType.edit)" class='searchBtn' size="sm" block color="success" @click="savePTAll()"><span>{{this.getLanguage["BTN"]["SV"]}}</span></CButton>
                    </div>
                </header>
            </div>
        </div>
    </div>
</template>

<script>
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import genericHelper from "@/modules/GenericHelper.js";
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { mapGetters, mapActions } from 'vuex';
    import { loadingFullScreen, constAccessType } from '@/modules/Constant.js';    
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading
        },
        data() {
            return {
                bool_showDetails: false,
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                bool_showPasteForm: false,
                int_Page: 1,//current Pagr
                int_IC: 1, // Item Count
                // dropdown value
                ddPTAgentList: null,
                ddAgentList: null,
                ddGameProviderList: null,
                ddCurrency: null,
                // search fields
                searchPTAgi: 0,
                searchAgi: 0,
                searchAgi2: 0,
                searchAgi3: 0,
                searchAgent: null,
                searchPTAgent: null,
                searchGameProviderId: [],
                searchCurrency: null,
                var_GP_DefaultPT: 0,
                var_GP_DefaultName: null,
                arr_providerList: {},
                arr_reportList: {},
                arr_GPPTList: {},
                arr_COPYLIST: {
                    PPT: 0,
                    CPT: 0,
                    SMPT: 0,
                    MAPT: 0,
                    AGPT: 0,
                },
                skipPageUpdate: false,
                dataType: 0,
                str_searchCurrency: 2,
                copyFormHasError: false,
                obj_Post: {
                    SelectedBrands: []
                },
                constAccessType: constAccessType,
            }
        },
        methods: {
            ...mapActions('UserInfo', ['setSearchCriteriaAGI']),
            generateFieldClass(data) {
                var cls = '';

                if (data.hasError) {
                    cls = 'form-group--error';
                }

                return cls;
            },
            generateFieldClassForCopyForm() {
                var cls = '';
                if (this.copyFormHasError) {
                    cls = 'form-group--error';
                }

                return cls;
            },
            getCurrencyList() {
                var that = this;
                that.ddCurrency = null;
                that.searchCurrency = null;
                var agi = [];
                if (this.searchAgi && (this.searchAgi2 == null || this.searchAgi2 == 0) && (this.searchAgi3 == null || this.searchAgi3 == 0)) {
                    agi = this.searchAgi;

                    this.getDataApi(`/api/dd/agilist/${agi}`,
                        function (d, s) {
                            if (s && d) {
                                agi = d.split(",");
                                that.obj_Post.SelectedBrands = agi;
                            } else {
                                agi = [0];
                                that.obj_Post.SelectedBrands = agi;
                            }
                            handleAgi();
                        });

                } else if (this.searchAgi && this.searchAgi2 && (this.searchAgi3 == null || this.searchAgi3 == 0)) {
                    agi = this.searchAgi2;

                    this.getDataApi(`/api/dd/agilist/${agi}`,
                        function (d, s) {
                            if (s && d) {
                                agi = d.split(",");
                                that.obj_Post.SelectedBrands = agi;
                            } else {
                                agi = [0];
                                that.obj_Post.SelectedBrands = agi;
                            }
                            handleAgi();
                        });
                } else if (this.searchAgi && this.searchAgi2 && this.searchAgi3) {
                    agi = [this.searchAgi3];
                    this.obj_Post.SelectedBrands = agi;
                    handleAgi();
                } else {
                    agi = [0];
                    that.obj_Post.SelectedBrands = agi;
                    handleAgi();
                }

                function handleAgi() {
                    that.postDataApi(`/api/dd/curbyagilist`, that.obj_Post,
                        function (d, s) {
                            if (s) {
                                that.ddCurrency = d.dropdownlist;
                                if (that.ddCurrency.length == 1) {
                                    that.searchCurrency = that.ddCurrency[0].id;
                                }
                            }
                        });
                }
            },
            loadPTAgentOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi('/api/dd/ag2/1/0/1',
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddPTAgentList = d.dropdownlist;
                        }
                        else {
                            that.ddPTAgentList = null;
                        }

                        callback();
                    });
            },

            selectPTAgentOptions(value, instanceId) {
                this.searchPTAgi = 0;
                this.dataType = this.getUserInfo.AT;

                if (value) {
                    var agentList = value.split("-");
                    this.searchPTAgi = agentList[agentList.length - 1];
                    this.dataType = agentList[0];
                }

                this.ddAgentList = null;
                this.searchAgi = 0;
                this.searchAgi2 = 0;
                this.searchAgi3 = 0;
                this.searchAgent = null;
                this.arr_providerList = [];
                this.arr_reportList = [];
            },
            loadAgentOptions({ action, callback, instanceId }) {
                var that = this;
                var agentURL = `/api/dd/ag2/0/0/0`;
                if (this.getUserInfo.AT == 3)
                    agentURL = `/api/dd/ag/1/0`;
                this.getDataApi(agentURL,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddAgentList = d.dropdownlist;
                        }
                        else {
                            that.ddAgentList = null;
                        }

                        callback();
                    });
            },
            selectAgentOptions(value, instanceId) {
                if (value) {
                    this.setSearchCriteriaAGI(value);
                }
                else {
                    this.setSearchCriteriaAGI(null);
                }

                this.searchAgi = 0;
                this.searchAgi2 = 0;
                this.searchAgi3 = 0;
                if (value) {
                    var temp = this.getAgentDetailList(this.ddAgentList, value);
                    if (temp) {
                        var t = temp.split("|");
                        if (t.length == 1) {
                            var agentList = t[0].split("-");
                            this.searchAgi = agentList[agentList.length - 1];
                        }
                        else if (t.length == 2) {
                            var agentList = t[1].split("-");
                            this.searchAgi = agentList[agentList.length - 1];

                            agentList = t[0].split("-");
                            this.searchAgi2 = agentList[agentList.length - 1];
                        }
                        else if (t.length == 3) {
                            var agentList = t[2].split("-");
                            this.searchAgi = agentList[agentList.length - 1];

                            agentList = t[1].split("-");
                            this.searchAgi2 = agentList[agentList.length - 1];

                            agentList = t[0].split("-");
                            this.searchAgi3 = agentList[agentList.length - 1];
                        }
                    }
                }
                this.getCurrencyList();
            },
            getAgentDetailList(list, value) {
                for (var i = 0; i < list.length; i++) {
                    if (list[i].id == value) {
                        return list[i].id;
                    }
                    else if (list[i].children && list[i].children.length > 0) {
                        var temp = this.getAgentDetailList(list[i].children, value);
                        if (temp) {
                            return temp + '|' + list[i].id;
                        }
                    }
                }

                return null;
            },
            selectGameProvider(value, instanceId) {

            },
            loadGameProviderOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi('/api/dd/game/prov/0/1/1',
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            for (var j = 0; j < d.dropdownlist.length; j++) {
                                if (d.dropdownlist[j].children != null && d.dropdownlist[j].children.length > 0) {
                                    for (var l = 0; l < d.dropdownlist[j].children.length; l++) {
                                        if (d.dropdownlist[j].children[l].label in that.getLanguage['GP'])
                                            d.dropdownlist[j].children[l].label = that.renderProviderName(d.dropdownlist[j].children[l].label);
                                    }

                                }
                            }

                            that.ddGameProviderList = that.appendSelectAllOption(d.dropdownlist);
                        }
                        else {
                            that.ddGameProviderList = null;
                        }
                        callback();
                        //if (that.searchGameProviderId > 0) {
                        //    that.selectGameProvider(that.searchGameProviderId);
                        //}
                    });
            },
            CountItem(value){
                if(this.int_IC!=1){
                    return value + ((this.int_IC-1) * this.int_RC);
                }
                else{
                    return value;
                }
            },
            getReportList() {
                if (!this.searchAgi) {
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MTA"]["BN"]), 1000);
                    return;
                } else if (!this.searchCurrency) {
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["GL"]["CURR"]), 1000);
                    return;
                }
                this.bool_fullLoading = true;
                this.bool_showPasteForm = false;
                var that = this;

                var path = '';
                var haveFilter = false;

                this.loadCurrencySymbol();

                if (this.searchAgi > 0) {
                    path += "&AGI=" + this.searchAgi;
                    haveFilter = true;
                }

                if (this.searchAgi2 > 0) {
                    path += "&AGI2=" + this.searchAgi2;
                    haveFilter = true;
                }

                if (this.searchAgi3 > 0) {
                    path += "&AGI3=" + this.searchAgi3;
                    haveFilter = true;
                }

                if (this.searchGameProviderId != null && this.searchGameProviderId.length == 1) {
                    path += "&GPI=" + this.searchGameProviderId;
                }
                else
                {
                    path += "&GPI_csv=" + this.searchGameProviderId;
                    haveFilter = true;
                }

                if (this.searchCurrency) {
                    path += "&CI=" + this.searchCurrency;
                    haveFilter = true;
                }

                if (((this.searchAgi > 0) || (this.searchAgi2 > 0) || (this.searchAgi3 > 0)) && (this.searchGameProviderId.length == 1)) {
                    this.bool_showPasteForm = true;
                }

                if (!haveFilter) {
                    this.bool_fullLoading = false;
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MTA"]["BN"]), 1000);
                    return;
                }

                if (path) {
                    path = path.substring(1);
                }
                if (this.bool_showPasteForm) {
                    this.getDataApi(`/api/ag/DGPPT?${path}`,
                        function (d, s) {                            
                            if (s) {                               
                                if (d.D && d.D.Items && d.D.Items.length > 0) {
                                    that.arr_GPPTList = d;
                                    that.var_GP_DefaultPT = d.D.Items[0].DPT;
                                    that.var_GP_DefaultName = d.D.Items[0].PN;
                                    that.arr_COPYLIST.CPT = 100 - that.var_GP_DefaultPT - that.arr_COPYLIST.SMPT - that.arr_COPYLIST.MAPT - that.arr_COPYLIST.AGPT;
                                }
                                else {
                                    that.arr_GPPTList = [];
                                    that.var_GP_DefaultPT = 0;
                                    that.var_GP_DefaultName = "";
                                    that.arr_COPYLIST.CPT = 0;
                                }
                            }
                        });
                }
                this.getDataApi(`/api/ag/ptagent?${path}`,
                    function (d, s) {                        
                        if (s) {
                            that.temp_agentName = null;

                            if (d.D && d.D.Items) {
                                var temp_agentName = null;
                                var temp_agentPC = null;
                                for (var i = 0; i < d.D.Items.length; i++) {
                                    d.D.Items[i].tempAGN = d.D.Items[i].AGN;
                                    if (temp_agentName == d.D.Items[i].AGN && temp_agentPC == d.D.Items[i].PC) {                                        
                                        d.D.Items[i].AGN = null;
                                    }
                                    else {
                                        temp_agentName = d.D.Items[i].AGN;
                                        temp_agentPC = d.D.Items[i].PC;
                                    }
                                }
                            }

                            that.arr_reportList = d.D.Items;
                            that.bool_fullLoading = false;
                        }
                        else {
                            that.arr_reportList = [];
                            that.bool_fullLoading = false;
                        }
                    });
                
                this.resizeTableHead();
            },

            loadCurrencySymbol() {

                try {
                    this.str_searchCurrency = this.ddCurrency.filter(obj => { return obj.id === this.searchCurrency })[0].label
                }
                catch (ex) {
                    this.str_searchCurrency = 2;

                }
            },
            copyPTtoAll() {
               
                if (!this.copyFormHasError) {
                    var arrayLength = this.arr_reportList.length;
                    for (let i = 0; i < arrayLength; i++) {
                        this.arr_reportList[i].PPT.PT = this.arr_COPYLIST.PPT;
                        this.arr_reportList[i].PT.PT = this.arr_COPYLIST.CPT;
                        this.arr_reportList[i].SAPT.PT = this.arr_COPYLIST.SMPT;
                        this.arr_reportList[i].MAPT.PT = this.arr_COPYLIST.MAPT;
                        this.arr_reportList[i].APT.PT = this.arr_COPYLIST.AGPT;
                        this.arr_reportList[i].dirty = true;
                    }
                }

            },
            savePTAll() {
                var that = this;
                var data = [];
                this.bool_fullLoading = true;
                var currencyId = null;
                var errMsg = '';

                if (this.searchCurrency > 0) {
                    currencyId = this.searchCurrency;
                }

                for (var i = 0; i < that.arr_reportList.length; i++) {

                    if (that.arr_reportList[i].dirty) {
                        if (that.arr_reportList[i].hasError) {
                            errMsg += that.arr_reportList[i].tempAGN + ' - ' + that.arr_reportList[i].PN + '<br/>';
                        }
                        else {
                            data.push({
                                PN: that.arr_reportList[i].PN,
                                GPI: that.arr_reportList[i].GPI,
                                UTS: that.arr_reportList[i].UTS,
                                PPT: that.arr_reportList[i].PPT,
                                PT: that.arr_reportList[i].PT,
                                SAPT: that.arr_reportList[i].SAPT,
                                MAPT: that.arr_reportList[i].MAPT,
                                APT: that.arr_reportList[i].APT,
                                CI: that.arr_reportList[i].CI
                            });
                        }
                    }
                }

                if (errMsg) {
                    that.bool_fullLoading = false;
                    that.showErrorMessage(null, that.utilGetErrorLanguage("ERR.10003") + "<br/>" + errMsg);
                }
                else if (!data || data.length == 0) {
                    // assume no data changed then return success message
                    that.bool_fullLoading = false;
                    that.getReportList();
                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                }
                else {
                    this.postDataApi(`/api/ag/spt-all`, { DT: data, CI: currencyId }, function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.getReportList();
                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                        }
                    }, true);
                }
            },
            changeProviderDefaultPT() {
                this.copyFormHasError = false;
                switch (this.dataType) {             //currently only superAdmin     
                    case 0:
                        this.arr_COPYLIST.CPT = 100 - this.var_GP_DefaultPT - this.arr_COPYLIST.SMPT - this.arr_COPYLIST.MAPT - this.arr_COPYLIST.AGPT;
                        if (this.var_GP_DefaultPT < 0 || this.arr_COPYLIST.CPT < 0 || this.arr_COPYLIST.SMPT < 0 || this.arr_COPYLIST.MAPT < 0 || this.arr_COPYLIST.AGPT < 0 ||
                            this.arr_COPYLIST.CPT === '' || this.arr_COPYLIST.CPT == null ||
                            ((this.arr_COPYLIST.SMPT === '' || this.arr_COPYLIST.SMPT == null)) ||
                            ((this.arr_COPYLIST.MAPT === '' || this.arr_COPYLIST.MAPT == null)) ||
                            ((this.arr_COPYLIST.AGPT === '' || this.arr_COPYLIST.AGPT == null))) {
                            this.copyFormHasError = true;
                        }
                    break;

                }

            },
            changePT(data) {
                data.dirty = true;
                data.hasError = false;
                
                if (this.bool_showPasteForm && this.dataType==0) {
                    data.PPT.PT = this.var_GP_DefaultPT;
                }

                switch (this.dataType) {
                    case 0:

                        data.PT.PT = 100 - this.getPTFromAttr(data.PPT) - this.getPTFromAttr(data.SAPT) - this.getPTFromAttr(data.MAPT) - this.getPTFromAttr(data.APT);

                        if (data.PPT.PT < 0 || data.PT.PT < 0 || data.SAPT.PT < 0 || data.MAPT.PT < 0 || data.APT.PT < 0 ||
                            data.PT.PT === '' || data.PT.PT == null ||
                            (data.SAPT.AGI && (data.SAPT.PT === '' || data.SAPT.PT == null)) ||
                            (data.MAPT.AGI && (data.MAPT.PT === '' || data.MAPT.PT == null)) ||
                            (data.APT.AGI && (data.APT.PT === '' || data.APT.PT == null))) {
                            data.hasError = true;
                        }
                        break;
                    case 1:
                        data.SAPT.PT = 100 - this.getPTFromAttr(data.PPT) - this.getPTFromAttr(data.MAPT) - this.getPTFromAttr(data.APT);

                        if (data.SAPT.PT < 0 || data.MAPT.PT < 0 || data.APT.PT < 0 ||
                            (data.SAPT.AGI && (data.SAPT.PT === '' || data.SAPT.PT == null)) ||
                            (data.MAPT.AGI && (data.MAPT.PT === '' || data.MAPT.PT == null)) ||
                            (data.APT.AGI && (data.APT.PT === '' || data.APT.PT == null))) {
                            data.hasError = true;
                        }
                        break;
                    case 2:
                        data.MAPT.PT = 100 - this.getPTFromAttr(data.PPT) - this.getPTFromAttr(data.APT);

                        if (data.MAPT.PT < 0 || data.APT.PT < 0 ||
                            (data.MAPT.AGI && (data.MAPT.PT === '' || data.MAPT.PT == null)) ||
                            (data.APT.AGI && (data.APT.PT === '' || data.APT.PT == null))) {
                            data.hasError = true;
                        }
                        break;
                }
            },
            getPTFromAttr(data) {
                if (!data) {
                    return 0;
                }

                return data.PT;
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:nth-child(2) td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            outputToConsole() {
                this.bool_fullLoading = true;
                this.bool_showPasteForm = false;
                var that = this;

                var path = '';
                var haveFilter = false;

                this.loadCurrencySymbol();

                if (this.searchAgi > 0) {
                    path += "&AGI=" + this.searchAgi;
                    haveFilter = true;
                }

                if (this.searchAgi2 > 0) {
                    path += "&AGI2=" + this.searchAgi2;
                    haveFilter = true;
                }

                if (this.searchAgi3 > 0) {
                    path += "&AGI3=" + this.searchAgi3;
                    haveFilter = true;
                }

                if (this.searchGameProviderId != null && this.searchGameProviderId.length == 1) {
                    path += "&GPI=" + this.searchGameProviderId;
                }
                else {
                    path += "&GPI_csv=" + this.searchGameProviderId;
                    haveFilter = true;
                }

                if (this.searchCurrency) {
                    path += "&CI=" + this.searchCurrency;
                    haveFilter = true;
                }

                if (((this.searchAgi > 0) || (this.searchAgi2 > 0) || (this.searchAgi3 > 0)) && (this.searchGameProviderId.length == 1)) {
                    this.bool_showPasteForm = true;
                }

                if (!haveFilter) {
                    this.bool_fullLoading = false;
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MTA"]["BN"]), 1000);
                    return;
                }

                if (path) {
                    path = path.substring(1);
                }
                window.open(`/api/ag/ptagentexx?${path}`, '_blank');
                if (this.bool_showPasteForm) {
                    this.getDataApi(`/api/ag/DGPPT?${path}`,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                if (d.D && d.D.Items && d.D.Items.length > 0) {
                                    that.arr_GPPTList = d;
                                    that.var_GP_DefaultPT = d.D.Items[0].DPT;
                                    that.var_GP_DefaultName = d.D.Items[0].PN;
                                    that.arr_COPYLIST.CPT = 100 - that.var_GP_DefaultPT - that.arr_COPYLIST.SMPT - that.arr_COPYLIST.MAPT - that.arr_COPYLIST.AGPT;
                                }
                                else {
                                    that.arr_GPPTList = [];
                                    that.var_GP_DefaultPT = 0;
                                    that.var_GP_DefaultName = "";
                                    that.arr_COPYLIST.CPT = 0;
                                }
                            }
                        });
                }
                this.getDataApi(`/api/ag/ptagentex?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.temp_agentName = null;

                            if (d.D && d.D.Items) {
                                var temp_agentName = null;
                                for (var i = 0; i < d.D.Items.length; i++) {
                                    d.D.Items[i].tempAGN = d.D.Items[i].AGN;
                                    if (temp_agentName == d.D.Items[i].AGN) {
                                        temp_agentName = d.D.Items[i].AGN;
                                        d.D.Items[i].AGN = null;
                                    }
                                    else {
                                        temp_agentName = d.D.Items[i].AGN;
                                    }
                                }
                            }

                            that.arr_reportList = d.D.Items;
                        }
                        else {
                            that.arr_reportList = [];
                        }
                    });
                this.resizeTableHead();
            }

        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserMemberSC', 'getUserInfo', 'checkModuleAccess']),
        },
        watch: {
        },
        created() {
            this.$parent.showSubMenu = 'AGS';
            this.$parent.showActiveMenu = 'AGS.APTRS';
            this.dataType = this.getUserInfo.AT;

            //this.getCurrencyList();
        },
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/AgentSetting/PositionTakingSetting.vue